import { Button, Col, Row } from "antd";
import { useEffect, useRef, useState } from "react";
import { FaImage } from "react-icons/fa6";
import bg from '../../../../assets/images/bg.png'
import { Colors } from "../../../../config";

export const BannerImage = (props) => {

    const [previewImage, setPreviewImage] = useState('');
    const [error, setError] = useState('')
    const imageRef = useRef(null)

    const [check, setCheck] = useState(true);

    const imageHandler = () => {
        imageRef.current.click()
    }

    useEffect(() => {
        if (props?.value && check) {
            setPreviewImage(props?.value)
        }
    }, [props?.value])

    const fileChooseHandler = (e) => {
        let selectedImg = e.target.files[0]
        if (selectedImg && !['image/jpeg', 'image/png'].includes(selectedImg?.type)) {
            setError('Format is invalid')
            props?.isError(true)
            return
        }
        else {
            setCheck(false)
            if (selectedImg) {
                const previewUrl = URL.createObjectURL(selectedImg)
                setPreviewImage(previewUrl)
                props?.onChange(selectedImg)
                setError('')
                props?.isError(false)
            }
        }
    }

    return (
        <Row className='w-full'>
            <Col span={24} className='flex items-center justify-center flex-col gap-2'>

                <div className=' w-full h-40 relative'>
                    <input type='file' ref={imageRef} onChange={fileChooseHandler} hidden />
                    <img className='w-full h-full object-cover object-center bg-[#f1f6fa]' src={previewImage || bg} />
                    <div className={`w-full flex flex-col items-center justify-center h-full gap-1 absolute top-0 z-10 ${previewImage ? ' opacity-70' : ''}`}>
                        <p className='text-sm text-gray-500'>Add Cover photo</p>
                        <Button
                            className='w-24 h-10 rounded-md outline-none border-none text-white'
                            style={{ background: Colors.AppYellow }}
                            onClick={imageHandler}
                            icon={<FaImage />
                            }
                        >
                            Upload
                        </Button>
                    </div>
                </div>
            </Col>
            {error && <p className="text-start text-red-400 text-lg">{error}</p>}
        </Row>
    )
}